export default __webpack_public_path__ + "static/media/settings_mobile.88fd444d.png";